import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import "./trendingThemes.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper";

import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/scrollbar";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import TrendingTheme from "./trendingTheme";

//will fetch activityTypes from bac
//will fetch themes from backend and map them to display each theme

export default function TrendingThemes({ setFooterTopPos }) {
  const { width } = useWindowDimensions();
  const themesRef = useRef(null);

  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.user);

  useEffect(() => {
    const top = themesRef.current.getBoundingClientRect().bottom;
    setFooterTopPos(top);
  }, []);

  const handleNavigate = () => {
    if (!isLoggedIn) return window.open(`/design`, "_blank");

    navigate(`/design`);
  };

  return (
    <div className="trending_themes" ref={themesRef}>
      <h2 className="trending_themes__header">Trending Themes</h2>
      <Swiper mousewheel={true} modules={[Mousewheel]} className="trending_themes__slider" slidesPerView={width <= 1100 ? "auto" : 4} spaceBetween={width <= 1100 ? 10 : 16} slidesPerGroup={1}>
        {trendingThemes.map((theme, idx) => {
          return (
            <SwiperSlide key={idx} className="swiper_slide" onClick={handleNavigate}>
              <TrendingTheme {...theme} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

const trendingThemes = [
  {
    img: "/assets/themes/theme1.png",
    name: "Holi Theme",
  },
  {
    img: "/assets/themes/theme2.png",
    name: "Support Ukraine",
  },
  {
    img: "/assets/themes/theme3.png",
    name: "Brand Theme",
  },
  {
    img: "/assets/themes/theme4.png",
    name: "Art Theme",
  },
  {
    img: "/assets/themes/theme5.png",
    name: "Earth day Theme",
  },
  {
    img: "/assets/themes/theme1.png",
    name: "Holi Theme",
  },
  {
    img: "/assets/themes/theme2.png",
    name: "Support Ukraine",
  },
];
